import { CanActivateFn } from '@angular/router';
import { Path } from '../constants/paths.constant';
import { createStorageGuard } from './utils/storage-guard.utils';

/**
 * Guard to protect reset-password route
 * Ensures OTP_ID and OTP_TOKEN exist in storage before allowing access
 * Note: OTP_TOKEN is separate from the auth TOKEN to avoid conflicts
 */
export const passwordResetStorageGuard: CanActivateFn = createStorageGuard(
  Path.RESET_PASSWORD
);
